import { render, staticRenderFns } from "./ResidenciaProfesionalDescargasPage.vue?vue&type=template&id=83fb5458&scoped=true&"
import script from "./ResidenciaProfesionalDescargasPage.vue?vue&type=script&lang=js&"
export * from "./ResidenciaProfesionalDescargasPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83fb5458",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/ResidenciaProfesionalDescargasPage.vue
// module id = 214
// module chunks = 17